import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { AnoSafra } from 'src/app/classes/AnoSafra';
import { Area } from 'src/app/classes/Area';
import { Atividade } from 'src/app/classes/Atividade';
import { enumProcessoPlanejamento } from 'src/app/classes/AtividadePlanejamento';
import { Cultura } from 'src/app/classes/Cultura';
import { GrupoOperacao } from 'src/app/classes/GrupoOperacao';
import { OrdemServico } from 'src/app/classes/OrdemServico';
import { Planejamento } from 'src/app/classes/Planejamento';
import { ProcessoPlanejamento } from 'src/app/classes/ProcessoPlanejamento';
import { Safra } from 'src/app/classes/Safra';
import { Setor } from 'src/app/classes/Setor';
import { AnoSafraService } from 'src/app/services/ano-safra.service';
import { AreaService } from 'src/app/services/area.service';
import { AtividadeService } from 'src/app/services/atividade.service';
import { CulturaService } from 'src/app/services/cultura.service';
import { EtapaService } from 'src/app/services/etapa.service';
import { GrupoOperacaoService } from 'src/app/services/grupo-operacao.service';
import { OrdemServicoService } from 'src/app/services/ordem-servico.service';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { ProcessoPlanejamentoService } from 'src/app/services/processo-planejamento.service';
import { SafraService } from 'src/app/services/safra.service';
import { SetorService } from 'src/app/services/setor.service';
import { StorageService } from 'src/app/services/storage.service';
import { DatepickerComponent } from 'src/app/theme/shared/components/datepicker/datepicker.component';
import { UtilsService } from 'src/app/utils/utils.service';
import { noWhitespaceValidator } from 'src/app/utils/validatorsCustom'

@Component({
  selector: 'app-detalhes-ordem-servico',
  templateUrl: './detalhes-ordem-servico.component.html',
  styleUrls: ['./detalhes-ordem-servico.component.scss']
})
export class DetalhesOrdemServicoComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() setorId: number;
  @Input() isSubmit: boolean;
  @Input() inserindo: boolean = false;
  @Input() ordemServico: OrdemServico;
  @Input() organizaPorSetor: boolean = false;
  @Output() OrdemServicoChangeEvento = new EventEmitter<OrdemServico>();
  @Output() AtividadeChangeEvento = new EventEmitter<any>();

  @ViewChild('DataPrevistaFinal', { static: false })
  DataPrevistaFinal: DatepickerComponent;

  safra: Safra;
  carregando: boolean = false;
  atividades: Atividade[];
  anoSafras: AnoSafra[] = [];
  @Input() culturas: Cultura[];
  @Input() areas: Area[];
  @Input() safras: Safra[];
  // TODO verificar
  //etapas: Etapa[];
  projetos: Safra[];
  projetoLoading: boolean = false;
  area: Area = new Area();
  planejamento: Planejamento = new Planejamento;
  setores: Setor[];
  usarProjetos: boolean = false;
  multiplo: boolean = false;
  areaPrevistaInicial: number = 0;
  processosPlanejamento: ProcessoPlanejamento[];
  processoPlantio: number;
  gruposOperacao: GrupoOperacao[];
  permissaoEditarOS: boolean = false

  culturaSelecionadaIcone: string = '';
  processoSelecionadoEhPlantio: boolean = false;

  constructor(public ordensServicoService: OrdemServicoService,
    private atividadeService: AtividadeService,
    private grupoOperacaoService: GrupoOperacaoService,
    private planejamentoService: PlanejamentoService,
    private safraService: SafraService,
    private culturaService: CulturaService,
    private areaService: AreaService,
    private etapaService: EtapaService,
    private utils: UtilsService,
    private setorService: SetorService,
    private storageService: StorageService,
    private anoSafraService: AnoSafraService,
    private processoPlanejamentoService: ProcessoPlanejamentoService,
    private cdr: ChangeDetectorRef,
  ) {

    var usuario = this.storageService.getUsuario();
    this.permissaoEditarOS = usuario.PermissaoUsuario.EditarOS;
    this.processoPlantio = enumProcessoPlanejamento.Plantio;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inserindo) {
      const usuario = this.storageService.getUsuario();
      this.permissaoEditarOS = usuario.PermissaoUsuario.EditarOS || (this.inserindo && usuario.PermissaoUsuario.IncluirOS);
    }
    if (changes.setorId && this.areas) {
      this.areas = this.areas.filter(x => x.SetorId == this.setorId);
    }
    if (changes.ordemServico && changes.ordemServico.currentValue && changes.ordemServico.currentValue.Id > 0) {
      const current = changes.ordemServico.currentValue as OrdemServico;
      const previous = changes.ordemServico.previousValue as OrdemServico;
      if (!previous || previous.Id !== current.Id) {
        if (current.FazendaId > 0) {
          this.selecionaFazenda(current.FazendaId, true);
        }

        this.getCulturas(true);
        this.selecionarSafra();
        if (current.AnoSafraId) {
          this.onAnoSafraChange();
        }
      }
    }
  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
  ngOnInit() {
    const usuario = this.storageService.getUsuario();
    this.permissaoEditarOS = usuario.PermissaoUsuario.EditarOS || (this.inserindo && usuario.PermissaoUsuario.IncluirOS);
    this.usarProjetos = this.storageService.getEmpresa().UsaProjetos;
    setTimeout(() => {

      forkJoin([
        this.processoPlanejamentoService.getProcessosPlanejamento(),
        this.setorService.getSetores(),
        this.atividadeService.getAtividadesParaUso(),
        this.grupoOperacaoService.getGruposOperacaoEmUso(),
      ]).subscribe(
        res => {
          this.processosPlanejamento = res[0];
          this.setores = res[1];
          const atividades: Atividade[] = res[2];
          this.gruposOperacao = res[3];
          atividades.forEach(a => {
            let grupo = this.gruposOperacao.filter(g => g.Id == a.GrupoOperacaoId);
            a.GrupoOperacaoDescricao = grupo.length > 0 ? grupo[0].Descricao : '';
          });
          this.atividades = atividades;
          // Garantir que o campo seja tratado como não selecionado quando vier 0
          if (this.ordemServico && (this.ordemServico.AtividadeId === 0 || this.ordemServico.AtividadeId === undefined)) {
            this.ordemServico.AtividadeId = null;
          }
          // Normalizar processo para null quando vier 0/undefined para o required funcionar
          if (this.ordemServico && (this.ordemServico.ProcessoPlanejamentoId === 0 || this.ordemServico.ProcessoPlanejamentoId === undefined)) {
            this.ordemServico.ProcessoPlanejamentoId = null;
          }
        },
        err => this.utils.getErro(err)
      );
      if (this.inserindo && this.ordemServico.FazendaId > 0) {
        this.selecionaFazenda(this.ordemServico.FazendaId, true);
      }

    }, 600);
  }

  osTimeout: any;
  ordemServicoChange() {

    if (this.osTimeout)
      clearTimeout(this.osTimeout);
    this.osTimeout = setTimeout(() => {
      this.OrdemServicoChangeEvento.emit(this.ordemServico)
      if (this.areaPrevistaInicial === 0) {
        this.areaPrevistaInicial = this.ordemServico.AreaPrevista;
      }
    }, 500);
  }

  getCulturas(isInit: boolean = false) {
    if (!this.ordemServico.SafraId) {
      this.culturas = [];
      return;
    }
    this.culturaService.getCulturasPorSafras([this.ordemServico.SafraId]).subscribe(ret => {
      this.culturas = ret
      if (!isInit && this.culturas.length > 0) {
        this.ordemServico.CulturaId = this.culturas[0].Id;
      }
      this.atualizarCulturaSelecionada();
    })
    this.ordemServicoChange();
  }

  selecionarSafra() {
    if (this.ordemServico.PlanejamentoId !== null && this.ordemServico.PlanejamentoId !== undefined && this.ordemServico.PlanejamentoId > 0) {
      this.planejamentoService.getPlanejamento(this.ordemServico.PlanejamentoId).subscribe((ret: Planejamento) => {
        let planejamento = ret;
        this.safraService.getSafra(planejamento.SafraId).subscribe(ret => {
          this.safra = ret;
        });
      });
    }
  }

  getCultura(id: number): Cultura {
    if (!this.culturas)
      return null;

    let cultura = this.culturas.filter(x =>
      x.Id == id
    );
    return cultura.length > 0 ? cultura[0] : new Cultura();
  }

  filtrarAtividade(term: string, item: Atividade) {
    term = term.toLowerCase();
    return item.Descricao.toLowerCase().indexOf(term) > -1 || (item.GrupoOperacaoDescricao ? item.GrupoOperacaoDescricao.toLowerCase().indexOf(term) > -1 : false);
  }

  selecionaFazenda(id: number, isInit: boolean = false) {
    this.ordemServico.FazendaId = id;
    if (this.inserindo && !isInit) {
      this.setorId = null;
      this.ordemServico.AreaId = null;
      this.ordemServico.SafraId = null;
      this.ordemServico.CulturaId = null;
      this.ordemServico.AnoSafraId = null;
    }
    this.carregando = true;
    forkJoin([
      this.areaService.getAreasPorFazenda(id),
      this.setorService.getSetoresPorFazenda(id),
      this.safraService.getSafrasPorAnoFazenda(0, id),
      this.anoSafraService.getAnosSafrasPorFazenda(id)
    ]).subscribe(
      res => {
        this.areas = res[0];
        this.setores = res[1];
        this.safras = res[2];
        this.anoSafras = res[3];
        this.carregando = false;
      },
      err => this.utils.getErro(err)
    )

    this.ordemServicoChange();
  }


  validacaoTamanhoAreaTimeout: any
  validarTamanhoArea() {
    if (this.multiplo)
      return;
    if (this.validacaoTamanhoAreaTimeout)
      clearTimeout(this.validacaoTamanhoAreaTimeout);

    if (!this.area.Id) {
      this.areaService.getArea(this.ordemServico.AreaId).subscribe(
        res => {
          this.area = res;
          if (this.ordemServico.AreaPrevista == 0 && this.areaPrevistaInicial > 0) {
            this.ordemServico.AreaPrevista = this.areaPrevistaInicial;
            this.ordemServicoChange();
          }
          this.validarTamanhoArea();
          return;
        },
        err => this.utils.getErro(err)
      )
    }


    this.validacaoTamanhoAreaTimeout = setTimeout(() => {
      if (!this.ordemServico.AreaId) {
        this.utils.handleWarning("Selecione um talhão");
        this.ordemServico.AreaPrevista = 0;
        this.ordensServicoService.emitirEventoAreaChange(true);
        return
      }

      const isPlanejada = this.ordemServico.Tipo === 2; // EnumTipoOS.Planejada
      const areaExcedePlanejado = isPlanejada && (this.ordemServico.AreaPrevista > this.areaPrevistaInicial && this.areaPrevistaInicial > 0);

      if (this.ordemServico.AreaPrevista > this.area.AreaTotal || this.ordemServico.AreaPrevista <= 0 || areaExcedePlanejado) {
        this.utils.handleWarning("Tamanho de área inconsistente!");
        this.ordemServico.AreaPrevista = this.areaPrevistaInicial;
        this.ordensServicoService.emitirEventoAreaChange(true);
        return;
      }

      this.ordemServicoChange();
      this.ordensServicoService.emitirEventoAreaChange(true);
    }, 1000);
  }

  selecionaArea() {
    if (this.multiplo) {
      this.ordemServico.AreaPrevista = this.areas
        .filter(x => this.ordemServico.AreasMultiplas.includes(x.Id))
        .reduce((total, area) => total + area.AreaTotal, 0)

      // Se usar setor e algum talhão tem setor, definir o setor automaticamente
      if (this.organizaPorSetor && this.ordemServico.AreasMultiplas.length > 0) {
        const areasSelecionadas = this.areas.filter(a => this.ordemServico.AreasMultiplas.includes(a.Id));
        const areasComSetor = areasSelecionadas.filter(a => a.SetorId && a.SetorId > 0);
        if (areasComSetor.length > 0) {
          // Se todos os talhões têm o mesmo setor, definir automaticamente
          const setoresUnicos = [...new Set(areasComSetor.map(a => a.SetorId))];
          if (setoresUnicos.length === 1) {
            this.setorId = setoresUnicos[0];
          }
        }
      }

      this.areaPrevistaInicial = this.ordemServico.AreaPrevista;
      this.ordemServicoChange();
      this.ordensServicoService.emitirEventoAreaChange(true);
    }
    else {
      if (this.ordemServico.AreaId) {
        // Buscar área nas áreas já carregadas primeiro
        const areaEncontrada = this.areas ? this.areas.find(a => a.Id === this.ordemServico.AreaId) : null;

        if (areaEncontrada) {
          this.area = areaEncontrada;
          this.ordemServico.AreaPrevista = this.area.AreaTotal;
          this.areaPrevistaInicial = this.area.AreaTotal;

          // Se usar setor e o talhão tem setor, definir o setor automaticamente
          if (this.organizaPorSetor && this.area.SetorId && this.area.SetorId > 0) {
            this.setorId = this.area.SetorId;
          }

          this.ordemServicoChange();
          this.ordensServicoService.emitirEventoAreaChange(true);
        } else {
          // Se não encontrou nas áreas carregadas, buscar no serviço
          this.areaService.getArea(this.ordemServico.AreaId).subscribe(
            ret => {
              this.area = ret;
              this.ordemServico.AreaPrevista = this.area.AreaTotal;
              this.areaPrevistaInicial = this.area.AreaTotal;

              // Se usar setor e o talhão tem setor, definir o setor automaticamente
              if (this.organizaPorSetor && this.area.SetorId && this.area.SetorId > 0) {
                this.setorId = this.area.SetorId;
              }

              this.ordemServicoChange();
              this.ordensServicoService.emitirEventoAreaChange(true);
            }
          );
        }
      }
    }
  }

  changeProcesso() {
    // Limpar seleção de operação agrícola sempre que o processo mudar
    this.ordemServico.AtividadeId = null;

    if (this.ordemServico.ProcessoPlanejamentoId) {
      this.atividadeService.getAtividadesPorProcesso(this.ordemServico.ProcessoPlanejamentoId).subscribe((res: Atividade[]) => {
        this.atividades = res;
        this.ordemServicoChange();
        this.AtividadeChangeEvento.emit();
      }, err => this.utils.getErro(err));
    } else {
      // Se não há processo selecionado, limpar atividades
      this.atividades = [];
      this.ordemServicoChange();
      this.AtividadeChangeEvento.emit();
    }
    this.atualizarProcessoSelecionado();
  }

  culturaChange() {
    this.ordemServicoChange();
    this.atualizarCulturaSelecionada();
  }

  private atualizarCulturaSelecionada() {
    const cultura = this.getCultura(this.ordemServico.CulturaId);
    this.culturaSelecionadaIcone = cultura && cultura.Icone ? cultura.Icone : '';
  }

  private atualizarProcessoSelecionado() {
    const proc = this.getProcessosPlanejamento(this.ordemServico.ProcessoPlanejamentoId);
    this.processoSelecionadoEhPlantio = !!(proc && proc.Plantio);
  }


  filtrarAreas() {
    this.areaService.getAreasPorFazenda(this.ordemServico.FazendaId).subscribe(
      ret => {
        this.areas = ret.filter(x => x.SetorId == this.setorId);
        this.ordemServico.AreaId = null;
        this.ordemServico.AreasMultiplas = [];
      }
    );
  }

  getProcessosPlanejamento(id: number): ProcessoPlanejamento {
    if (this.processosPlanejamento)
      return this.processosPlanejamento.find(x => x.Id == id);
    else
      return new ProcessoPlanejamento();
  }

  tempoUpdate: any;

  validateDataPrevista(data: Date) {
    this.ordemServico.DataPrevista = data;

    if (!this.validarDataPrevista()) {
      this.utils.handleWarning("Data Prevista não pode ser maior que Data Prevista Final!");
    }

    this.ordemServicoChange();
  }

  validateDataPrevistaFinal(data: Date) {
    this.ordemServico.DataPrevistaFinal = data;

    if (!this.validarDataPrevista()) {
      this.utils.handleWarning("Data Prevista Final deve ser maior ou igual à Data Prevista!");
      this.ordemServico.DataPrevistaFinal = this.ordemServico.DataPrevista;
      if (this.DataPrevistaFinal) {
        this.DataPrevistaFinal.setData(this.ordemServico.DataPrevista.toISOString().split('T')[0]);
      }
    }

    this.ordemServicoChange();
  }

  validarDataPrevista(): boolean {
    if (!this.ordemServico.DataPrevista || !this.ordemServico.DataPrevistaFinal) {
      return true;
    }

    const dataInicio = new Date(this.ordemServico.DataPrevista);
    const dataFim = new Date(this.ordemServico.DataPrevistaFinal);

    // DataPrevista não pode ser maior que DataPrevistaFinal, mas podem ser iguais
    return dataInicio <= dataFim;
  }



  dataEValida(data) {
    if (typeof this.ordemServico.DataPrevista == 'string') {
      return this.ordemServico.DataPrevista <= data.toISOString();
    }
    return this.ordemServico.DataPrevista <= data;
  }

  changeMultiplosTalhoes() {
    this.ordemServico.AreasMultiplas = [];
    this.ordemServico.AreaPrevista = 0;
    this.ordemServico.AreaId = null;
    this.ordensServicoService.emitirEventoAreaChange(true);
  }

  talhaoTemSetor(): boolean {
    if (!this.organizaPorSetor) {
      return false;
    }

    if (this.ordemServico.AreaId && this.ordemServico.AreaId > 0) {
      const areaSelecionada = this.areas ? this.areas.find(a => a.Id === this.ordemServico.AreaId) : null;
      if (areaSelecionada && areaSelecionada.SetorId && areaSelecionada.SetorId > 0) {
        return true;
      }
      if (this.area && this.area.SetorId && this.area.SetorId > 0) {
        return true;
      }
    }

    if (this.ordemServico.AreasMultiplas && this.ordemServico.AreasMultiplas.length > 0 && this.areas) {
      const areasSelecionadas = this.areas.filter(a => this.ordemServico.AreasMultiplas.includes(a.Id));
      return areasSelecionadas.some(a => a.SetorId && a.SetorId > 0);
    }

    return false;
  }

  getFormulario(): FormGroup {
    return new FormGroup({
      DescricaoEtapa: new FormControl(this.ordemServico.DescricaoEtapa, [
        Validators.required,
      ]),
    })
  }

  onAnoSafraChange(): void {
    this.projetoLoading = true;
    if (this.ordemServico.AnoSafraId == null) {
      this.projetos = [];
      this.projetoLoading = false;
      return;
    }
    this.safraService.listarProjetosPorAnoSafra(this.ordemServico.AnoSafraId).subscribe(
      (res) => {
        this.projetos = res;
        this.projetoLoading = false;
      },
      (err) => {
        this.utils.getErro(err);
        this.projetoLoading = false;
      }
    );
  }
}
